/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Print_FailedInputs */

const vi_sinp_print_failed = /** @type {(inputs: Sinp_Print_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không mở được cửa sổ in phiếu. Trình duyệt đang chặn cửa sổ in, hãy cho phép rồi bấm in lại.`)
};

/**

* @param {Sinp_Print_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_print_failed = /** @type {((inputs?: Sinp_Print_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Print_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_print_failed(inputs)
});